import { CircularProgress, Grid, Button } from "@material-ui/core";
import { createStyles, withStyles } from "@material-ui/core/styles";
// Asets
import classnames from "classnames";
import CommonCss from "commonCss";
import Image from "Components/Common/image.jsx";
import LanguageIcon from "@material-ui/icons/Language";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import PhoneIcon from "@material-ui/icons/Phone";
import TwitterIcon from "@material-ui/icons/Twitter";
// import Cart from "Components/Application/Components/Evaluate/Components/Common/Cart";
import ReadMore from "Components/Common/ReadMore";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
// Redux
import { clearStoreState } from "redux/applications/action";
import { updateDrawerStyle } from "redux/drawer/action";
import { createEvaluationCart, removeProductFromCart } from "redux/evaluation/cart/action";
import LayeredCard from "Components/Application/Components/Evaluate/Components/Common/LayeredCard";
import { showSnackBar } from "redux/snackbar/action";
import { fireEvent } from "redux/common/action";
import AppBarV2 from "Components/Application/AppBarV2";
import Breadcrumb from "Components/Common/Breadcrumb";
import { fetchVendorById } from "redux/vendor/action";
// import AddVendorOptionDialog from "Components/Common/Dialogs/AddVendorOptionDialog";

const connectedProps = (state) => ({
  evaluationCart: state.evaluationCart.evaluation,
  userRole: state.authUser.user?.Role,
  orgUser: state.orgUser,
  fetchVendorDetailsProgress: state.vendors.fetchVendorDetailsProgress,
  fetchVendorDetailsError: state.vendors.fetchVendorDetailsError,
  vendorDetails: state.vendors.vendorDetails,
  addVendorDialogOpen: state.vendorCatalog.addVendorDialogOpen,
});

const connectionActions = {
  updateDrawerStyle: updateDrawerStyle,
  createEvaluationCart: createEvaluationCart,
  removeProductFromCart: removeProductFromCart,
  showSnackBar: showSnackBar,
  clearStoreState: clearStoreState,
  fireEvent: fireEvent,
  fetchVendorById: fetchVendorById,
};

var connector = connect(connectedProps, connectionActions);

const styles = (theme) =>
  createStyles({
    ...CommonCss.ProductDetails,

    rootContainer: {
      ...CommonCss.rootContainer,
      marginTop: 15,
    },
    productLink: {
      color: "#0093E0 !important",
      marginBottom: 15,
      textDecoration: "underline",
      fontSize: 16,
    },
    linkItem: {
      cursor: "pointer !important",
    },
    cursorTag: {
      fontSize: "12px",
      borderRadius: "25px",
      padding: "10px 14px",
      cursor: "pointer",
    },
    emptyText: {
      textAlign: "center",
      height: 50,
      paddingTop: 20,
    },
    addProductLink: {
      cursor: "pointer",
      textDecoration: "underline",
    },
    mailTo: {
      color: "#4A87F8 !important",
      textDecoration: "underline",
    },
    favLiked: {
      zIndex: 11,
      color: "#f44336",
    },
    whislistedUsers: {
      marginLeft: 20,
      display: "flex",
      cursor: "pointer",
      background: "#f1f1f1",
      borderRadius: "25px",
      padding: "5px 10px",
    },
    productLeftSection: {
      maxWidth: 200,
      width: 200,
      minWidth: "auto",
      position: "sticky",
      top: 20,
      alignSelf: "flex-start",
    },
    list: {
      overflowY: "auto",
      maxHeight: "calc(100vh - 280px)",
      padding: "0px 30px 30px 0px",
      fontSize: "13px",
      listStyle: "none",
      marginTop: "30px",
      marginLeft: "0",
      paddingLeft: "0",
    },
    detailsLabel: {
      fontSize: "16px",
      fontWeight: "500",
      display: "inline",
    },
    detailsValue: {
      fontSize: "16px",
      marginBottom: 20,
      display: "inline",
    },
    infoWrap: {
      display: "flex",
      gap: 15,
    },
    empCount: {
      fontSize: 16,
    },
    addVendorButton: {
      float: "right",
      marginRight: "30px",
      background: "#3C3C3C",
      borderRadius: 5,
      color: "#fff",
      fontSize: theme.spacing(1.9),
      minHeight: 32,
      minWidth: 175,
      marginTop: 10,
      "&:hover": {
        background: "#3C3C3C",
      },
    },
    sendBtn: {
      padding: "6px 20px",
      fontWeight: 500,
      marginLeft: 10,
    },
  });

class VendorDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is404: false,
      showMoreServices: false,
      showMoreSoftwareProducts: false,
      isCartShow: false,
      headerSectionWidth: null,
      productType: "VENDOR",
    };
    this.addToCart = this.addToCart.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    setTimeout(() => {
      this.props.updateDrawerStyle(false, true);
    }, 100);
    this.props.fetchVendorById(this.props.match?.params?.id);
    setTimeout(() => {
      this.updateDimensions();
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match?.params?.id) {
      this.props.fetchVendorById(this.props.match?.params?.id);
    }

    this.cartDrawer(prevProps);

    if (!this.props.fetchVendorDetailsProgress && prevProps.fetchVendorDetailsProgress) {
      if (this.props.fetchVendorDetailsError?.message && this.props.fetchVendorDetailsError?.message !== null) {
        this.setState({ is404: true });
      }
    }
  }

  cartDrawer = (preProps) => {
    if (
      (this.props.evaluationCart && this.props.evaluationCart.Products && this.props.evaluationCart.Products.length) !==
      (preProps.evaluationCart && preProps.evaluationCart.Products && preProps.evaluationCart.Products.length)
    ) {
      this.setState({ isCartShow: true });
      setTimeout(() => {
        this.setState({ isCartShow: false });
      }, 2000);
    }
  };

  scrollContent = (e) => {
    e.persist();
  };

  addToCart(item) {
    if (this.props.evaluationCart == null) {
      this.props.createEvaluationCart(item.id);
      this.props.showSnackBar("Product added to evaluation", "success", 3000);
    } else {
      var addedToCart = this.props.evaluationCart == null ? [] : this.props.evaluationCart.Products.map((p) => p.id);
      if (addedToCart.indexOf(item.id) !== -1) {
        this.props.removeProductFromCart(this.props.evaluationCart.id, item.id);
      } else {
        this.props.createEvaluationCart(item.id, this.props.evaluationCart.ID);
        this.props.showSnackBar("Product added to evaluation", "success", 3000);
      }
    }
  }

  addVendorToCart() {
    let id = this.props.match?.params?.id;
    if (this.props.evaluationCart == null) {
      this.props.createEvaluationCart(parseInt(id), null, "MASTER_VENDOR");
    } else {
      var addedToCart = this.props.evaluationCart == null ? [] : this.props.evaluationCart?.Products?.filter((p) => parseInt(p.EntityID) === parseInt(id));
      if (addedToCart && addedToCart.length > 0) {
        this.props.removeProductFromCart(this.props.evaluationCart.ID, parseInt(addedToCart[0].EntityObjectID));
      } else {
        this.props.createEvaluationCart(parseInt(id), this.props.evaluationCart.ID, "MASTER_VENDOR");
      }
    }
  }

  cartOpen = () => {
    this.setState({ isCartShow: true });
  };

  cartClose = () => {
    this.setState({ isCartShow: false });
  };

  updateDimensions = () => {
    const headerSectionWidth = this.divElement?.clientWidth;
    if (this.state.headerSectionWidth !== headerSectionWidth) {
      this.setState({ headerSectionWidth });
    }
  };

  render() {
    const classes = this.props.classes;

    if (this.props.fetchVendorDetailsProgress || this.state.is404) {
      return (
        <div>
          <AppBarV2 title="Vendor Details" withBack={true} dropdown={true} />
          <div className={classes.productDetails}>
            {this.state.is404 && (
              <div style={{ width: "100%", textJustify: "center", textAlign: "center" }}>
                <p className={classes.productName}>404</p>
                <p className={classes.emptyText}>No vendor found</p>
              </div>
            )}
            {!this.state.is404 && (
              <div style={{ textAlign: "center", marginTop: 20, width: "100%" }}>
                <CircularProgress />
              </div>
            )}
          </div>
        </div>
      );
    }

    const { vendorDetails } = this.props;
    var isCart = this.props.evaluationCart !== null;
    var addedToCart = this.props.evaluationCart == null ? [] : this.props.evaluationCart.Products.map((p) => p.ID);

    const { headerSectionWidth } = this.state;
    const isSm = headerSectionWidth >= 768 && headerSectionWidth <= 1200 ? true : false;

    var addedVendorCart = this.props.evaluationCart == null ? [] : this.props.evaluationCart?.Products?.map((p) => parseInt(p.EntityID));
    let id = parseInt(this.props.match?.params?.id);
    let icon = addedVendorCart.indexOf(id) === -1 ? "+" : "-";

    return (
      <div>
        <AppBarV2 title="Vendor Details" withBack={true} dropdown={true} />
        <Breadcrumb routeList={[{ name: "Vendors", path: "/app/vendors/all-vendors" }, { name: "Details" }]} />

        <div className={classnames(classes.productDetails, classes.rootContainer)}>
          <div className={classes.productLeftSection}>
            <Image src={vendorDetails?.logo ? vendorDetails?.logo : ""} style={{ maxWidth: "90%" }} />

            <ul className={classes.list}>
              {vendorDetails?.description && (
                <li className={classes.item}>
                  <a href="#about" className={this.state.activeNumber === 0 ? "active" : ""} onClick={() => this.setState({ activeNumber: 0 })}>
                    About {vendorDetails?.name}
                  </a>
                </li>
              )}

              {vendorDetails?.products?.length ? (
                <li className={classes.item}>
                  <a href="#products" className={this.state.activeNumber === 1 ? "active" : ""} onClick={() => this.setState({ activeNumber: 1 })}>
                    Products
                  </a>
                </li>
              ) : null}

              {vendorDetails?.services?.length ? (
                <li className={classes.item}>
                  <a href="#services" className={this.state.activeNumber === 1 ? "active" : ""} onClick={() => this.setState({ activeNumber: 1 })}>
                    Services
                  </a>
                </li>
              ) : null}
            </ul>
          </div>
          <div className={classes.productRightSection}>
            <div className={classes.ProductNameSection}>
              <p className={classes.productName}>{vendorDetails?.name}</p>
              <Button
                className={classes.filterSection}
                style={{ minWidth: 175 }}
                onClick={() => {
                  this.addVendorToCart();
                }}
              >
                {icon} Evaluate
              </Button>
            </div>

            <div className={classes.contentSection} onScroll={(e) => this.scrollContent(e)}>
              <div className={classes.itemSection} id="about">
                {vendorDetails?.description && (
                  <>
                    <p className={classes.head}>About {vendorDetails?.name}</p>
                    <p className={classes.description}>
                      <ReadMore charLimit={1500}>{vendorDetails?.description}</ReadMore>
                    </p>
                  </>
                )}
                {vendorDetails?.website && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <LanguageIcon />
                    </div>
                    <a rel="noopener noreferrer" target="_blank" href={"//" + vendorDetails?.website} className={classes.productLink}>
                      {vendorDetails?.website}
                    </a>
                  </div>
                )}
                {vendorDetails?.email && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <EmailIcon />
                    </div>
                    <a rel="noopener noreferrer" target="_blank" href={"mailto:" + vendorDetails?.email} className={classes.productLink}>
                      {vendorDetails?.email}
                    </a>
                  </div>
                )}
                {vendorDetails?.phone_number && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <PhoneIcon />
                    </div>
                    <div className={classes.detailsValue}>{vendorDetails?.phone_number}</div>
                  </div>
                )}
                {vendorDetails?.linkedin_page && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <LinkedInIcon style={{ color: "#0077b5" }} />
                    </div>
                    <a rel="noopener noreferrer" target="_blank" href={vendorDetails?.linkedin_page} className={classes.productLink}>
                      {vendorDetails?.linkedin_page}
                    </a>
                  </div>
                )}
                {vendorDetails?.twitter_page && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <TwitterIcon style={{ color: "#1DA1F2" }} />
                    </div>
                    <a rel="noopener noreferrer" target="_blank" href={vendorDetails?.twitter_page} className={classes.productLink}>
                      {vendorDetails?.twitter_page}
                    </a>
                  </div>
                )}
                {vendorDetails?.facebook_page && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>
                      <FacebookIcon style={{ color: "#4267B2" }} />
                    </div>
                    <a rel="noopener noreferrer" target="_blank" href={"//" + vendorDetails?.facebook_page} className={classes.productLink}>
                      {vendorDetails?.facebook_page}
                    </a>
                  </div>
                )}
                {vendorDetails?.number_emp_min && vendorDetails?.number_emp_max && (
                  <div className={classes.infoWrap}>
                    <div className={classes.detailsLabel}>Employee Range : </div>
                    <div className={classes.empCount}>{vendorDetails?.number_emp_min + " - " + vendorDetails?.number_emp_max}</div>
                  </div>
                )}
                <br />
              </div>

              {vendorDetails?.products?.length > 0 && (
                <div className={classes.itemSection} id="products">
                  <h3 className={classes.head}>Products</h3>
                  <Grid container spacing={3}>
                    {vendorDetails?.products?.slice(0, !this.state.showMoreSoftwareProducts ? 6 : vendorDetails?.products.length).map((product, k) => {
                      return (
                        <Grid item lg={isSm ? 3 : 2} md={isCart ? 4 : 3} sm={isCart ? 12 : 6} xs={12} key={"product_" + product.master_product_id}>
                          <LayeredCard
                            title={product.name}
                            image={product.product_logo}
                            onClick={() => {}}
                            numLayer={0}
                            checked={addedToCart.indexOf(product.master_product_id) !== -1}
                            showCheckbox={true}
                            toogleCheck={() => {
                              this.addToCart(product);
                            }}
                            id={product.master_product_id}
                            uniqueId={product.master_product_id + "_v_" + k}
                            type={"product"}
                            IsExisting={product.IsExisting}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  {vendorDetails?.products && vendorDetails?.products.length > 6 && (
                    <div style={{ textAlign: "center", padding: "35px 15px" }}>
                      <span className={classes.show_more} onClick={() => this.setState({ showMoreSoftwareProducts: !this.state.showMoreSoftwareProducts })}>
                        {this.state.showMoreSoftwareProducts === false ? "Show more" : "Show less"}
                      </span>
                    </div>
                  )}
                </div>
              )}

              {vendorDetails?.services?.length > 0 && (
                <div className={classes.itemSection} id="services">
                  <p className={classes.head}>Services</p>
                  <p className={classes.description}>
                    <ul className={classes.UL}>
                      {vendorDetails?.services.map((item, k) => {
                        return (
                          <li
                            key={k}
                            style={{ marginRight: "14px" }}
                            onClick={() => {
                              this.props.history.push(`/app/vendors/${item.master_vendor_id}/service/${item.master_service_id}`);
                            }}
                          >
                            <span className={classnames(classes.cursorTag, classes.inverse)}>{item.name}</span>
                          </li>
                        );
                      })}
                    </ul>
                  </p>
                </div>
              )}

              <p className={classes.emptyText} style={{ alignItem: "center" }}>
                The information you see in this page is compiled from multiple sources. If you have any feedback, please contact us at{" "}
                <a className={classes.mailTo} href="mailto:sellers@expent.ai">
                  sellers@expent.ai
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connector(compose(withStyles(styles))(VendorDetails));
